import { QueryClient, type DefaultOptions } from '@tanstack/react-query';

const queryOptions: DefaultOptions = {
  queries: {
    retry: 0,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  },
  mutations: {
    throwOnError: true,
  },
};

export const queryClient = new QueryClient({
  defaultOptions: queryOptions,
});
